import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreateProductTypeErrorsMapper, CreateProductTypeMapper } from '../mappers';
import { CreateProductTypeDto } from '../dtos';

export type ICreateProductTypeRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ICreateProductTypeRepo = IRepo<[CreateProductTypeDto, string | number | undefined], ICreateProductTypeRepoResponse>;

export const CreateProductTypeRepoType = Symbol.for('CreateProductTypeRepo');

@bind(CreateProductTypeRepoType)
export class CreateProductTypeRepo implements ICreateProductTypeRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreateProductTypeDto) {
    try {
      const body = new FormData();
      const mappedBody = CreateProductTypeMapper.toPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = dto.id ? urlMaker('/api/admin/product-types/edit') : urlMaker('/api/admin/product-types/create');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = CreateProductTypeErrorsMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
